import {svgIconWrapper} from '../svg-icon-wrapper';

import LocationPinCircleSolid from './location-pin-circle-solid-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;
    const resolvedColor = validProps.color || validProps.fill || 'black';
    validProps.style = {
        color: resolvedColor,
        ...(validProps.style || {}),
    };

    return <LocationPinCircleSolid {...validProps} />;
}
SvgComponent.iconName = 'locationPinCircleSolid';

export const LocationPinCircleSolidIcon = svgIconWrapper(SvgComponent);
